export const listStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

export const rowStyles = ({ palette }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'baseline',
  gap: 2,
  flexWrap: 'wrap',
  padding: 1,
  borderRadius: 1,
  backgroundColor: palette.background.default,
  border: `1px solid ${palette.divider}`,
});

export const labelStyles = ({ palette }) => ({
  color: palette.text.secondary,
  flexShrink: 0,
});

export const valueStyles = ({ palette }) => ({
  color: palette.text.primary,
  textAlign: 'right',
  wordBreak: 'break-word',
});
